import React from "react";
import { Link, Outlet } from "react-router-dom";
import "./authSplitLayout.css";

export default function AuthSplitLayout() {
  return (
    <div className="authSplitRoot">
      <div className="authSplitCard">
        <div className="authSplitBrand">
          <div className="authSplitBrandInner">
            <Link to="/" className="authSplitLogo">
              <img src="/mrehabIcon.png" alt="" width={44} height={44} />
              <span>mRehab</span>
            </Link>
            <p className="authSplitKicker">Upper-limb practice at home</p>
            <h1 className="authSplitHeadline">
              Sign in to track sessions, orders, and progress with your care
              team.
            </h1>
            <p className="authSplitBody">
              mRehab supports stroke survivors and clinicians with structured
              home tasks and dashboards, alongside your existing medical care.
            </p>
            <div className="authSplitArt">
              <img
                src="/images/product/mug-and-bowl-still-image.jpeg"
                alt=""
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>
        <div className="authSplitForm">
          <Outlet />
          <p style={{ marginTop: "var(--space-4)", fontSize: "0.8125rem", textAlign: "center" }}>
            <Link to="/privacy" className="ui-link">
              Privacy policy
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
